import React, { Fragment } from 'react';
import styled from './../themes/themed-styled-components';
import { Property } from 'csstype';

type SectionProps = {
    padding?: number|string
}

type StyleProps = {
    textColor?: string;
    backgroundColor?: string;
    fontWeight?: Property.FontWeight;
}


export type LoadingUnitIdentifierProps = StyleProps & {
    identifier?: string|null/*,
    padSections?: boolean*/
}

const Container = styled.span<StyleProps>`
    white-space: nowrap;
    font-family: ${({ theme }) => theme.fontFamilyMonospace};
    
    color: ${({ textColor }) => textColor ?? 'inherit'};
    background-color: ${({ backgroundColor }) => backgroundColor ?? 'transparent'};
    font-weight: ${({ fontWeight }) => fontWeight ?? 'normal'};
`;

const Padded = styled.span`
    margin-left: ${({ padding = 0 as Property.Padding }: SectionProps) => padding ?? 0};
    color: inherit;
`;

const imoContainerRegex = /^([a-z]{4})([0-9]{6})([0-9])$/i;
const trailerPlateRegex = /^([a-z]{2})([0-9]{3})([a-z]{2})$/i;
const trailerPlateOldRegex = /^([a-z]{2,3})([0-9]{5,6})$/i;


const LoadingUnitIdentifier = ({ identifier = null/*, padSections = true*/, ...props }: LoadingUnitIdentifierProps): JSX.Element => {

    if (identifier === null) {
        return <Fragment />;
    }

    let idfr = identifier.trim().toUpperCase();

    let m = imoContainerRegex.exec(idfr);

    if (m != null) {
        return (<Container  {...props }>
            {m[1]}
            <Padded padding="0.4em" {...props}>{m[2]}</Padded>
            <Padded padding="0.2em" {...props}>{m[3]}</Padded>
        </Container>);
    }

    m = trailerPlateRegex.exec(idfr);

    if (m != null) {
        return (<Container {...props}>
            {m[1]}
            <Padded padding="0.2em" {...props}>{m[2]}</Padded>
            <Padded padding="0.2em" {...props}>{m[3]}</Padded>
        </Container>);
    }

    m = trailerPlateOldRegex.exec(idfr);

    if (m != null) {
        return (<Container {...props}>
            {m[1]}
            <Padded padding="0.2em" {...props}>{m[2]}</Padded>
        </Container>);
    }

    return <Container {...props}>{idfr}</Container>
}

export default LoadingUnitIdentifier;